export default {
  getPrice(services: {
    price_ht: number;
    price: number;
    is_chosen: boolean;
    plafond: boolean;
    paidByClient: boolean;
    step: number;
    enabled: boolean;
    value_chosen: number;
  }[], exclTax: boolean) {
    const price = exclTax ? 'price_ht' : 'price';
    const total = services?.reduce((acc, elem) => {
      elem.paidByClient = true;
      elem.plafond = true;
      if (elem.is_chosen && elem.plafond && elem.paidByClient) {
        return acc + (elem.step && elem.enabled ? (elem.value_chosen || 0) / elem.step : 1)
          * elem[price];
      }
      return acc;
    }, 0);
    return Math.round(total * 100) / 100;
  },
};
